import React, { useMemo } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store/index";
//基础样式
import "rmc-picker/assets/index.css";
import "rmc-date-picker/assets/index.css";
import "rmc-picker/assets/popup.css";
import "antd-mobile/dist/antd-mobile.css";
import "./style.less";
import "rsuite/lib/styles/index.less";
//路由
import Routes from "./routes";
import { getUrlParams } from "./utils";
import config from "./config";

const Root = () => {
  useMemo (() => {
    const search = getUrlParams (window.location.search);
    const sid = search.sid ? search.sid : "2";
    const user_id = search.user_id;
    const company_id = search.company_id;
    user_id && sessionStorage.setItem ("user_id", user_id);
    company_id && sessionStorage.setItem ("company_id", company_id);
    config.sid = sid;
  }, []);
  return (
    <Provider store={store}>
      <Routes/>
    </Provider>
  );
};

ReactDOM.render (<Root/>, document.getElementById ("root"));
